import { cn } from 'common/utils';
import React from 'react';

const AttentionFilled = ({
  size = 12,
  color = '#084D6E',
  onClick,
  className,
}) => {
  return (
    <svg
      className={cn({ 'cursor-pointer': onClick }, className)}
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 12 13'
      fill='none'
      onClick={onClick}
    >
      <g clipPath='url(#clip0_8866_201674)'>
        <path
          d='M12 0.351562H0V12.3516H12V0.351562Z'
          fill='white'
          fillOpacity='0.01'
        />
        <path
          d='M6 11.3516C7.3807 11.3516 8.6307 10.7919 9.53553 9.88709C10.4404 8.98226 11 7.73226 11 6.35156C11 4.97086 10.4404 3.72086 9.53553 2.81603C8.6307 1.91121 7.3807 1.35156 6 1.35156C4.6193 1.35156 3.3693 1.91121 2.46446 2.81603C1.55964 3.72086 1 4.97086 1 6.35156C1 7.73226 1.55964 8.98226 2.46446 9.88709C3.3693 10.7919 4.6193 11.3516 6 11.3516Z'
          fill={color}
          stroke={color}
          strokeWidth='0.8'
          strokeLinejoin='round'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M5.99919 9.38999C6.22743 9.38999 6.41245 9.20497 6.41245 8.97673C6.41245 8.7485 6.22743 8.56348 5.99919 8.56348C5.77096 8.56348 5.58594 8.7485 5.58594 8.97673C5.58594 9.20497 5.77096 9.38999 5.99919 9.38999Z'
          fill='white'
          stroke='white'
          strokeWidth='0.3'
        />
        <path
          d='M6 3.35156V7.35156'
          stroke='white'
          strokeWidth='0.8'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_8866_201674'>
          <rect
            width='12'
            height='12'
            fill='white'
            transform='translate(0 0.351562)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AttentionFilled;
